import { useState, useEffect } from "react";

function useCheckIsMobile() {
  const [size, setSize] = useState([0, 0]);
  const [isMobileWidth, setIsMobileWidth] = useState(false);

  useEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    if (size[0] <= 425) {
      setIsMobileWidth(true);
    } else {
      setIsMobileWidth(false);
    }
  }, [size]);

  return { isMobileWidth, size };
}

export default useCheckIsMobile;
